import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LegendToggleIcon(props: IconProps) {
    return <Icon {...props} iconKey={"legend_toggle"}/>
}
